/**
 * this component has been extended for bpcollections as well because of the similar behaviour of rp and bp
 * all the naming of variables and functions is according to the rp , but applies to the bp as well
 */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { DateRangePicker } from 'react-dates';
import { toastr } from 'react-redux-toastr';
import styles from './rpCollections.scss';
import { setPageName } from '../../../services/pageService/pageActionCreator';
import * as rpCollectionsActions from './rpCollectionsRedux/rpCollectionsActionCreator';
import SearchBox from '../../commons/searchBox/searchBox';
import DateRangeFilter from '../../commons/dateFilter/dateFilter';
import Select from '../../commons/formElements/select/select';
import ZoomTable from '../../commons/zoomTable/zoomTable';
import Loader from '../../commons/loader/loader';
import AlertsBar from '../../commons/alertsBar/alertsBar';
import { filterTableData } from './rpCollectionsHelper';
import {
  isRpAdmin,
  isZoomFinanceManager,
  shouldTableDataBeFetchedForNewDateRange
} from '../../../services/helpers';
import ConfirmationModal from '../../commons/confirmationModal/confirmationModal';
import FnfSettlementModal from '../../commons/fnfSettlementModal/fnfSettlementModal';
import FnfDetailsTable from './fnfDetailsTable';

const dropdownIcnUrl = require('../../../assets/images/dropdown_icn.svg');
const downloadSymbolUrl = require('../../../assets/images/download-symbol.svg');

/*
 * @flow
 * @file: RpCollections.js
 * @description: Container for Retail Partner Wallet Payment Summary.
 * @date: 25.01.2023
 */

const RpCollections = props => {
  const [state, setState] = useState({
    resetSearchText: false,
    tableData: [],
    searchString: '',
    isLoaded: false,
    paymentModeOptions: [
      { key: 'Cash', val: 'Cash' },
      { key: 'Cheque', val: 'Cheque' },
      { key: 'Online', val: 'Online' },
      { key: 'Write-Off', val: 'Write-Off' },
      { key: 'Bank_Transfer', val: 'Bank Transfer' },
      { key: 'Wallet_Deduction', val: 'WALLET_DEDUCTION' }
    ],
    paymentModeSelectedOption: '',
    collectedByOptions: [],
    filteredTableData: [],
    orgId: null // will store the orgId when selected by RPadmin or BpAdmin
  });

  const [isUserRpAdmin, setIsUserRpAdmin] = useState(false);
  const [isUserFinanceManager, setIsUserFinanceManager] = useState(false);

  const { parentProps } = props;
  const { routeProps } = parentProps;
  const { expenseType } = routeProps; // expenseType will be BP for bp-collections page and RP for rp-collections page

  const pageObj = {
    pageName:
      expenseType === 'BP' ? 'BP Collection Summary' : 'RP Collection Summary',
    betaPage: false
  };

  // @var: reportDate - contains the start and end date of the transaction report to be fetched.

  const [reportDate, setReportDate] = useState({
    startDate: null,
    endDate: null
  });
  const [focusedInput, setFocusedInput] = useState(null);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showFnfModal, setShowFnfModal] = useState(false);

  const RP_COLLECTION_HANDOVER_PENDING = 'RP_COLLECTION_HANDOVER_PENDING';
  const RP_COLLECTION_HANDOVER_COMPLETED = 'RP_COLLECTION_HANDOVER_COMPLETED';

  const tabs = [
    {
      key: RP_COLLECTION_HANDOVER_PENDING,
      name: 'Handover Pending'
    },
    {
      key: RP_COLLECTION_HANDOVER_COMPLETED,
      name: 'Handover Completed'
    }
  ];
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [showCnKnockOffConfirmation, setShowCnKnockOffConfirmation] = useState(
    false
  );
  const [consignmentIdToKnockOff, setConsignmentIdToKnockOff] = useState(null);
  const [consignmentCnoteToKnockOff, setConsignmentCnoteToKnockOff] = useState(
    null
  );

  /*
   * @var props: {
   *  setPageName: function -> setPageName from pageActionCreator,
   *  rpCollectionsData: object -> rpCollectionsData from rpCollectionsReducer,
   *  userProfile: object -> userProfile from userProfileReducer,
   *  actions: object -> rpCollectionsActions from rpCollectionsActionCreator,
   *  }
   */

  const { setPageName, rpCollectionsData, userProfile, actions } = props;
  const {
    amountBalance,
    vanNumber,
    handoverPendingData,
    handoverCompletedData,
    handoverPendingAmount,
    handoverCompletedAmount,
    isLoading,
    isKnockOffInProgress,
    isLoadingBalance,
    filterDates,
    fnfSettlementDto,
    orgCode,
    rpList // list will contain rps and bps for rpAdmins and BpAdmins respectively
  } = rpCollectionsData;

  const {
    approveFnf,
    confirmFnfAmount,
    getAmountBalance,
    getHandoverPendingData,
    getHandoverCompletedData,
    downloadTransactionReport,
    knockOffConsignment,
    setFilterDates,
    getRpListForRpAdmin
  } = actions;

  const alertMessage =
    'No data found for the selected date range. Please select a different date range.';

  const initCall = async () => {
    setShowCnKnockOffConfirmation(false);
    setConsignmentCnoteToKnockOff(null);
    setConsignmentIdToKnockOff(null);
    getAmountBalance(state.orgId, expenseType);
    getHandoverPendingData(
      filterDates.startDate,
      filterDates.endDate,
      state.orgId,
      expenseType
    );
    getHandoverCompletedData(
      filterDates.startDate,
      filterDates.endDate,
      state.orgId,
      expenseType
    );
  };

  const onTabChange = tab => {
    setSelectedTab(tab);
    setState({ ...state, isLoaded: false });
    if (tab.key === RP_COLLECTION_HANDOVER_COMPLETED) {
      setState({
        ...state,
        tableData: handoverCompletedData,
        filteredTableData: handoverCompletedData,
        isLoaded: true
      });
    } else if (tab.key === RP_COLLECTION_HANDOVER_PENDING) {
      setState({
        ...state,
        tableData: handoverPendingData,
        filteredTableData: handoverPendingData,
        isLoaded: true
      });
    }
  };

  const toggleDatePicker = () => {
    setShowDatePicker(!showDatePicker);
  };

  const toggleFnfModal = () => {
    if (handoverPendingAmount !== 0) {
      var str =
        'FNF Settlement can be done only if wallet handover is not pending.';
      toastr.error('Error', str);
      return;
    }

    const isFnfAmountUnavailable =
      amountBalance === null || amountBalance === undefined;
    if (isFnfAmountUnavailable) {
      toastr.error(
        'Error',
        'FNF wallet amount is not available and can not be confirmed.'
      );
      return;
    }
    if (fnfSettlementDto && fnfSettlementDto.requestedAt) {
      toastr.warning(
        'Already Settled',
        'FnF Settlement can be done only once.'
      );
      return;
    }
    setShowFnfModal(!showFnfModal);
  };

  const handleFnfSettlementClick = () => {
    if (orgCode) {
      confirmFnfAmount(orgCode, expenseType, amountBalance);
      setShowFnfModal(!showFnfModal);
    } else {
      toastr.error('Error', 'Organisation Code is not available.');
    }
  };

  const setDownloadReportDates = ({ startDate, endDate }) => {
    let start;
    let end;
    if (startDate) {
      start = moment(startDate).startOf('day');
    }
    if (endDate) {
      end = moment(endDate).endOf('day');
    }
    setReportDate({ startDate: start, endDate: end });
  };

  const onFocusChange = val => {
    setFocusedInput(val);
  };

  const downloadReport = () => {
    if (reportDate.startDate && reportDate.endDate) {
      downloadTransactionReport(
        reportDate.startDate.format('x'),
        reportDate.endDate.format('x'),
        state.orgId,
        expenseType
      );
      setShowDatePicker(false);
    } else {
      toastr.error('Error', 'Please select both start and end date');
    }
  };

  const handleDateRangeChange = (from, to) => {
    // Checking if previous date range is same as new date range
    if (
      shouldTableDataBeFetchedForNewDateRange(
        { startDate: from, endDate: to },
        filterDates
      )
    ) {
      // If new date range is different from previous date range then fetch table data for new date range
      getHandoverCompletedData(from, to, state.orgId, expenseType);
      getHandoverPendingData(from, to, state.orgId, expenseType);
    }
    setFilterDates(from, to);
  };

  const knockOffConfirmationModalHandler = () => {
    setShowCnKnockOffConfirmation(true);
  };
  const tableActionFunctions = {
    RP_COLLECTION_HANDOVER_PENDING: Object.assign(
      {},
      {
        knockOff: (consignmentId, consignmentCnote) => {
          // passing initcall as callback to knockOffConsignment to refresh the table data after knockoff
          setConsignmentIdToKnockOff(consignmentId);
          setConsignmentCnoteToKnockOff(consignmentCnote);
          knockOffConfirmationModalHandler();
        }
      }
    ),
    RP_COLLECTION_HANDOVER_COMPLETED: {}
  };

  const onSearchValueChange = val => {
    const filteredTableData = filterTableData(state.tableData, {
      searchString: val,
      paymentModeSelectedOption: state.paymentModeSelectedOption
    });
    setState({ ...state, filteredTableData, searchString: val });
  };

  const onPaymentModeChange = val => {
    const filteredTableData = filterTableData(state.tableData, {
      searchString: state.searchString,
      paymentModeSelectedOption: val
    });
    setState({ ...state, filteredTableData, paymentModeSelectedOption: val });
  };

  const onRpChange = val => {
    setState({ ...state, orgId: val });
  };

  useEffect(() => {
    setFilterDates(
      moment()
        .subtract(6, 'days')
        .startOf('day')
        .format('x'),
      moment()
        .endOf('day')
        .format('x')
    );
  }, []);

  /**
   * triggered everytime a rp or bp is selected from the dropdown
   */
  useEffect(() => {
    if (state.orgId) {
      initCall();
    }
  }, [state.orgId]);

  const disableFiltersForRpAdmin = () => {
    return isUserRpAdmin && !state.orgId;
  };
  const rejectCnKnockOffHandler = () => {
    setShowCnKnockOffConfirmation(false);
  };

  const confirmCnKnockOffHandler = () => {
    knockOffConsignment(
      consignmentIdToKnockOff,
      initCall,
      expenseType,
      state.orgId
    );
  };
  // Calling the initial API call on mount ,
  // calls the balance , pending and complete handover apis for rp's and bp's
  // and list of rps and bps for rpAdmins and bpAdmins respectively
  useEffect(() => {
    let isUserRpAdmin = isRpAdmin(userProfile);
    let isUserFM = isZoomFinanceManager(userProfile);
    setIsUserRpAdmin(isUserRpAdmin);
    setIsUserFinanceManager(isUserFM);
    if (isUserRpAdmin) {
      getRpListForRpAdmin(expenseType);
    } else {
      if (
        userProfile &&
        filterDates &&
        filterDates.startDate &&
        filterDates.endDate
      ) {
        initCall();
      }
    }
    setPageName(pageObj);
  }, []);

  const filterRpList = (elem, searchStr) => {
    if (!searchStr) {
      return true;
    }
    return (
      (elem &&
        elem.name &&
        elem.name.toLowerCase().includes(searchStr.toLowerCase())) ||
      (elem &&
        elem.code &&
        elem.code.toLowerCase().includes(searchStr.toLowerCase()))
    );
  };

  useEffect(() => {
    if (
      handoverCompletedData &&
      selectedTab.key === RP_COLLECTION_HANDOVER_COMPLETED
    ) {
      setState({
        ...state,
        tableData: handoverCompletedData,
        filteredTableData: handoverCompletedData,
        isLoaded: true
      });
    }
  }, [handoverCompletedData]);

  useEffect(() => {
    if (
      handoverPendingData &&
      selectedTab.key === RP_COLLECTION_HANDOVER_PENDING
    ) {
      setState({
        ...state,
        tableData: handoverPendingData,
        filteredTableData: handoverPendingData,
        isLoaded: true
      });
    }
  }, [handoverPendingData]);

  const RenderLoader = () => {
    return (
      <Loader
        imgStyles={{ height: '3rem', width: '3rem' }}
        customStyles={{
          height: '1.5rem',
          width: '1.5rem',
          transform: 'translatey(10px)'
        }}
        message=""
      />
    );
  };
  return (
    <div className={styles.rpCollectionsWrapper}>
      <div className={`${styles.filterPanelParent} l-row a-center`}>
        <div className={`${styles.filterPanelLeft} l-row flex-70`}>
          <div className={`${styles.filterLabel} l-row a-center`}>
            Filter By:
          </div>
          <div className={`${styles.filterComponentWrapper}`}>
            <DateRangeFilter
              disabled={disableFiltersForRpAdmin()}
              setDateFilter={handleDateRangeChange}
              displayFormat="DD MMM YY"
              isOutsideRangeCheck={true}
              preventSetDateByDefault={true}
            />
          </div>
          <div className={`${styles.filterComponentWrapper}`}>
            <Select
              styles={{
                background: !disableFiltersForRpAdmin() ? '' : '#cacccd'
              }}
              disabled={disableFiltersForRpAdmin()}
              label="Payment mode"
              optionsArrOfObj={state.paymentModeOptions}
              onSelect={val => {
                onPaymentModeChange(val);
              }}
            />
          </div>
          {isUserFinanceManager && state.orgId && (
            <div className={`${styles.filterComponentWrapper}`}>
              <button
                type="button"
                className={`${styles.fnfBtn}`}
                onClick={toggleFnfModal}
              >
                FnF Settlement
              </button>
            </div>
          )}
        </div>
        {/* fnf settlement modal */}
        <FnfSettlementModal
          fnfAmount={amountBalance}
          showModal={showFnfModal}
          closeModal={() => setShowFnfModal(false)}
          handleSubmitClick={() => handleFnfSettlementClick()}
          styles={{}}
        />

        {/* Transaction Report Download */}
        <div className={`${styles.filterPanelRight} l-row flex-30 j-end`}>
          <div className={`${styles.filterComponentWrapper}`}>
            <div className={`${styles.transactionReportDownloadWrapper}`}>
              <button
                disabled={disableFiltersForRpAdmin()}
                type="button"
                className={`${styles.downloadBtn} ${styles.transactionReportBtn} btn btn-primary`}
                onClick={toggleDatePicker}
              >
                Transaction Report
                <div className={styles.dropdownIcn}>
                  <img src={dropdownIcnUrl} alt="dropdown" />
                </div>
              </button>
              <button
                disabled={disableFiltersForRpAdmin()}
                type="button"
                className={`${styles.downloadBtn} btn`}
                onClick={downloadReport}
              >
                <img src={downloadSymbolUrl} alt="Download Report" />
              </button>
              {showDatePicker && (
                <div className={styles.datePickerWrapper}>
                  <DateRangePicker
                    disabled={disableFiltersForRpAdmin()}
                    startDate={reportDate.startDate}
                    startDateId="startDate"
                    endDate={reportDate.endDate}
                    endDateId="endDate"
                    focusedInput={focusedInput}
                    onFocusChange={onFocusChange}
                    onDatesChange={setDownloadReportDates}
                    isOutsideRange={day => {
                      if (focusedInput === 'endDate') {
                        return (
                          day.isAfter(moment(new Date())) ||
                          day.isBefore(reportDate.startDate)
                        );
                      }
                      if (focusedInput === 'startDate') {
                        return (
                          day.isAfter(moment(new Date())) ||
                          day.isAfter(reportDate.endDate)
                        );
                      }
                      return day.isAfter(
                        moment(new Date().setHours(23, 59, 59))
                      );
                    }}
                    showClearDates={true}
                    displayFormat="DD MMM YY"
                  />
                </div>
              )}
            </div>
          </div>
          <div className={`${styles.filterComponentWrapper}`}>
            <SearchBox
              disabled={disableFiltersForRpAdmin()}
              onSearchValueChange={val => onSearchValueChange(val)}
              resetSearchText={state.resetSearchText}
            />
          </div>
        </div>
      </div>
      <div className={`${styles.filterPanelParent} l-row a-center`}>
        {isUserRpAdmin && (
          <div className={`${styles.filterComponentWrapper}`}>
            <Select
              disabled={false}
              disableNone={true}
              label={expenseType === 'RP' ? 'Select RP' : 'Select BP'}
              optionsArrOfObj={rpList}
              enableSearch={true}
              nameValStrings={{
                nameKey: 'id'
              }}
              filterFunction={filterRpList}
              displayAccessorFunction={ele => ele.name + '  ' + ele.code}
              onSelect={val => {
                onRpChange(val);
              }}
            />
          </div>
        )}
        {(!isUserRpAdmin || isUserFinanceManager || state.orgId) && (
          <>
            {/* Total Amount Balance */}
            <div className={`${styles.summaryInfoBox}`}>
              <div
                style={{
                  backgroundColor: isLoadingBalance ? 'transparent' : 'white'
                }}
                className={`${styles.summaryCardUp} j-center`}
              >
                <div className={`${styles.totalAmountTag}`}>Van Number:</div>
                {isLoadingBalance ? (
                  <RenderLoader />
                ) : (
                  <div className={`${styles.totalAmount}`}>
                    {vanNumber || '-'}
                  </div>
                )}
              </div>
              <div className={`${styles.summaryCardUp} j-center`}>
                <div className={`${styles.totalAmountTag}`}>
                  {' '}
                  Amount Balance:{' '}
                </div>
                {isLoadingBalance ? (
                  <RenderLoader />
                ) : (
                  <div className={`${styles.totalAmount}`}>
                    &#8377;
                    {amountBalance ? Math.round(amountBalance * 100) / 100 : 0}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {isUserFinanceManager && state.orgId ? (
        <>
          {fnfSettlementDto && Object.keys(fnfSettlementDto).length > 0 && (
            <FnfDetailsTable
              data={fnfSettlementDto}
              handleClick={() => {
                if (
                  !fnfSettlementDto ||
                  (fnfSettlementDto && Object.keys(fnfSettlementDto).length < 1)
                ) {
                  toastr.error(
                    'Error',
                    'FnF settlement details are unavailable, can not proceed to approve.'
                  );
                  return;
                }
                if (props && props.userProfile && props.userProfile.user_id) {
                  approveFnf(
                    expenseType,
                    fnfSettlementDto,
                    props.userProfile.user_id
                  );
                } else {
                  toastr.error(
                    'Error',
                    'User ID is missing, can not proceed to approve.'
                  );
                  return;
                }
              }}
            />
          )}
        </>
      ) : null}

      {(!isUserRpAdmin || state.orgId) && (
        <>
          {/* Tabs for Handover Pending and Handover Completed */}
          <div className={`${styles.tabsContainer}`}>
            {tabs.map((tab, index) => (
              <div
                className={`${styles.tab}
            ${tab.key === selectedTab.key ? styles.active : ''}
          `}
                key={index}
                onClick={() => onTabChange(tab)}
              >
                <div className={`${styles.tabName}`}>{tab.name}</div>
                <div className={`${styles.tabCount}`}>
                  {/* Total Amount of individual tabs*/}
                  {tab.key === RP_COLLECTION_HANDOVER_PENDING ? (
                    <div className={`${styles.totalAmount}`}>
                      &#8377;
                      {isLoading ? (
                        <Loader message="" />
                      ) : handoverPendingAmount ? (
                        Math.round(handoverPendingAmount * 100) / 100
                      ) : (
                        0
                      )}
                    </div>
                  ) : (
                    <div className={`${styles.totalAmount}`}>
                      &#8377;
                      {isLoading ? (
                        <Loader message="" />
                      ) : handoverCompletedAmount ? (
                        Math.round(handoverCompletedAmount * 100) / 100
                      ) : (
                        0
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
          {/* Table */}
          <div className={`${styles.tableWrapper}`}>
            {state && state.isLoaded === false ? (
              <Loader />
            ) : state &&
              state.isLoaded &&
              state.tableData &&
              state.tableData.length ? (
              <ZoomTable
                configKey={selectedTab.key}
                tableDataLength={state.filteredTableData.length}
                tableData={state.filteredTableData}
                actionFunctions={tableActionFunctions[selectedTab.key]}
              />
            ) : (
              <AlertsBar
                message={alertMessage}
                loading={state.isLoaded === false}
              />
            )}
          </div>
        </>
      )}

      {/*  confirmation Modal */}
      <ConfirmationModal
        minWidth="40%"
        showLoader={isKnockOffInProgress}
        showModal={showCnKnockOffConfirmation}
        closeModal={() => setShowCnKnockOffConfirmation(false)}
        title="CONFIRM CN KNOCK OFF"
        heading={`Are you sure you want to knock off CN: ${consignmentCnoteToKnockOff}`}
        confirm={confirmCnKnockOffHandler}
        reject={rejectCnKnockOffHandler}
      />
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  parentProps: ownProps,
  rpCollectionsData: state.rpCollectionsData,
  userProfile: state.userProfile
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(rpCollectionsActions, dispatch),
  setPageName: pageObj => dispatch(setPageName(pageObj))
});

export default connect(mapStateToProps, mapDispatchToProps)(RpCollections);
